module.exports = __webpack_public_path__ + "static/media/menu-close-icon.609fe8f5.svg";